import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const AI_TRAINING_CONFIG = enabledOn(PlatformSlug.CasperBooster)

export const isAiTrainingAvailable = (slug?: PlatformSlug) => isFeatureAvailable(AI_TRAINING_CONFIG, slug)
